import { render, staticRenderFns } from "./CourseRequest.vue?vue&type=template&id=9da2f128"
import script from "../../services/student/course-request.js?vue&type=script&lang=js&external"
export * from "../../services/student/course-request.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports